module.exports = __webpack_public_path__ + "static/media/aboutPicture.0eb0cf1a.png";